"use client";

import LeadersCarousel from "@/modules/leaderboard/components/leaders-carousel";
import { useCountryContext } from "@/providers/country-provider";

export const Vips = () => {
	const { vips, country } = useCountryContext();
	return (
		<>
			<h1 className="text-center text-[28px] font-bold text-[#0056E8]">{vips.title}</h1>

			<LeadersCarousel className="mt-5" country={country} />
		</>
	);
};
